import { GateIncludesEnum } from './gates.model';

export interface IOperatorPayload {
  parkingLotId: string;
  firstName?: string;
  lastName?: string;
  fullName: string;
  username: string;
  password: string;
  role: string;
  phone: string;
  identityId: string;
  isActive: boolean;
}

export interface IOperatorItem {
  id: string;
  parkingLotId: string;
  fullName: string;
  firstName: string;
  lastName: string;
  username: string;
  role: OperatorRoleEnum;
  phone: string;
  isActive: boolean;
  lastLoginAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface IOperatorParams {
  Id?: string;
  Includes?: GateIncludesEnum;
  ParkingLotId?: string;
  IsActive?: boolean;
  Role?: OperatorRoleEnum;
  SortOrder?: string;
  OrderBy?: string;
  PageIndex?: number;
  PageSize?: number;
  UserName?: string;
}

export enum OperatorRoleEnum {
  Admin = 'ADMIN',
  Operator = 'OPERATOR',
  Personal = 'TECHNICAL_STAFF',
}

export const IOperatorRoleLabel: Record<OperatorRoleEnum, string> = {
  [OperatorRoleEnum.Admin]: 'Админ',
  [OperatorRoleEnum.Operator]: 'Оператор',
  [OperatorRoleEnum.Personal]: 'Тех персонал',
};
